import React from 'react'
import PropTypes from 'prop-types'

import { Container, Image, Button } from 'react-bootstrap'

import styles from './../style/Produkciya.module.scss'

class ProdukciyaDirs extends React.Component {

  render() {

    const { produkciya_page } = this.props

    return (
      <div className={styles.section}>
        <Container>
          <div className={styles.items}>
            {produkciya_page.map( ( elm, k ) => (
              <div className={styles.elm}>
                <Image className={styles.elm_image} src={elm?.image} width={287} height={150} alt={elm?.name} />
                <div className={styles.elm_content}>
                  <Button
                    className={styles.button}
                    href={elm?.href}
                    variant='primary'
                    onClick={() => {}}
                  >
                    <div className={styles.button_icon}>
                      <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.09082 7.90998L7.909 1.0918M7.909 1.0918H2.45446M7.909 1.0918V6.54634" strokeLinecap="round"/>
                      </svg>
                    </div>
                    <div className={styles.button_text}>Подробнее</div>
                  </Button>
                  <div className={styles.elm_name}>{elm?.name}</div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </div>
    )
  }
}

ProdukciyaDirs.propTypes = {
  produkciya_page: PropTypes.array
}

ProdukciyaDirs.defaultProps = {
  produkciya_page: []
}

export default ProdukciyaDirs